import { useFormikContext } from 'formik'

export function useFormContext<T = any>() {
  const formik = useFormikContext<T>()

  if (!formik) {
    throw new Error('could not find form context; please make sure the component is wrapped in a <Form>.')
  }

  return formik
}
